/**
 * Permission utility functions
 * 
 * This module provides utility functions for checking user permissions
 * throughout the application.
 */

/**
 * Check if user has any of the specified permissions
 * 
 * @param {string[]} userPermissions - Array of user's permissions
 * @param {string[]} requiredPermissions - Array of required permissions
 * @param {boolean} isSuper - Whether user is a super admin
 * @returns {boolean} True if user has permission, false otherwise
 */
export const hasPermission = (userPermissions = [], requiredPermissions = [], isSuper = false) => {
  // Super admin has all permissions
  if (isSuper === 1) {
    return true;
  }

  // Check if user has any of the required permissions
  return requiredPermissions.some(permission => 
    userPermissions.includes(permission)
  );
};

/**
 * Check if user has all of the specified permissions
 * 
 * @param {string[]} userPermissions - Array of user's permissions
 * @param {string[]} requiredPermissions - Array of required permissions
 * @param {boolean} isSuper - Whether user is a super admin
 * @returns {boolean} True if user has all permissions, false otherwise
 */
export const hasAllPermissions = (userPermissions = [], requiredPermissions = [], isSuper = false) => {
  // Super admin has all permissions
  if (isSuper === 1) {
    return true;
  }

  // Check if user has all of the required permissions
  return requiredPermissions.every(permission => 
    userPermissions.includes(permission)
  );
};

/**
 * Permission constants for organizations
 */
export const ORGANIZATION_PERMISSIONS = {
  READ: 'organizations-list',
  CREATE: 'organizations-create',
  UPDATE: 'organizations-update',
  DELETE: 'organizations-delete'
};

/**
 * Permission constants for individual customers
 */
export const INDIVIDUAL_CUSTOMER_PERMISSIONS = {
  READ: 'ind-customer-list',
  CREATE: 'ind-customer-creation',
  UPDATE: 'ind-customer-update',
  DELETE: 'ind-customer-delete'
};

/**
 * Permission constants for organization users
 */
export const ORG_USER_PERMISSIONS = {
  READ: 'org-user-read',
  CREATE: 'org-user-create',
  UPDATE: 'org-user-edit',
  DELETE: 'org-user-delete'
};